import { supabase } from "@/lib/supabase";

export type WriteSource = "ui" | "grok" | "claude";

export type WriteSourceTable =
  | "expenses"
  | "quotes"
  | "tasks"
  | "contacts"
  | "documents"
  | "site_daily_logs";

export function isMissingWriteSourceColumn(message: string): boolean {
  return /source/i.test(message) && /schema cache|column|does not exist|could not find/i.test(message);
}

export function normalizeWriteSource(source: string | null | undefined): WriteSource {
  if (source === "grok" || source === "claude" || source === "ui") return source;
  if (source === "bot") return "grok";
  return "ui";
}

/**
 * Insert with `source`. If migration 078 is not applied yet, retry without the column
 * so the screen keeps saving.
 */
export async function insertWithWriteSource<T>(
  table: WriteSourceTable,
  values: Record<string, unknown>,
  source: WriteSource = "ui"
): Promise<T> {
  const first = await supabase
    .from(table)
    .insert({ ...values, source } as never)
    .select("*")
    .single();
  if (first.error && isMissingWriteSourceColumn(first.error.message)) {
    const second = await supabase
      .from(table)
      .insert(values as never)
      .select("*")
      .single();
    if (second.error) throw new Error(second.error.message);
    if (second.data == null) throw new Error("No data returned");
    return second.data as T;
  }
  if (first.error) throw new Error(first.error.message);
  if (first.data == null) throw new Error("No data returned");
  return first.data as T;
}
